<div class="score-card-container {{additionalStyleClass}}" [title]="subTitle ? subTitle + ' Score': 'Score'">
  <div class="content {{backgroundColor}}"><span>{{ score | number:'1.2-2'}}</span></div>
  <div *ngIf="subTitle" class="footer">
    <span>{{subTitle}}</span>
  </div>
</div>
